<ngx-file-drop class="d-flex" (onFileOver)="isFileOverDropZone = true" (onFileLeave)="isFileOverDropZone = false" [disabled]="disabled"
               (onFileDrop)="isUploading = true; fileDroppedSubject.next($event)" [style.cursor]="(disabled ? 'default' : 'pointer')">
  <ng-template style="width: 100%" ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
    <div class="upload-container text-center" [ngStyle]="{'max-width': width, 'height': height}">
      <div [ngStyle]="{'margin': margin}">
        <div class="d-inline-flex" *ngIf="!preview" style="margin-top: 14px">
          <i *ngIf="!file && !preview && !disabled && !fileURL" class="fas fa-cloud-upload"
             [ngClass]="isUploading ? 'upload-icon-hover' : 'upload-icon'"></i>
          <i *ngIf="!(!file && !preview && !disabled && !fileURL)"
             class="fas fa-file-alt upload-icon-hover"></i>
        </div>
        <br *ngIf="!preview">
        <div *ngIf="!isUploading && !file && !preview && !disabled && !fileURL" style="margin-top: 14px; padding-bottom: 10px">
          <div style="display: inline-flex">
            <span class="upload-container-text d-none d-md-block" style="margin-right: 4px">Drag file here or</span>
            <beaconstac-button
              [disabled]="disabled"
              (onClick)="overrideClick ? onClicked() : browse.click()"
              [label]="inputText ? inputText : 'browse'" [style]="'text'"
            ></beaconstac-button>
          </div>

          <ng-container *ngIf="!inputSubText">
            <div class="mt-2" style="font-size: 13px; font-style: normal; font-weight: 400; line-height: 15px;
            letter-spacing: 0.25px; color: #979797;"
                 *ngIf="dimension && maxSize">{{dimension}} pixels. {{maxSize/1000000}}MB max file size.
              <span *ngIf="custom"> {{custom}}</span>
            </div>
          </ng-container>
          <ng-container *ngIf="inputSubText">
            <div class="mt-2" style="font-size: 13px; font-style: normal; font-weight: 400; line-height: 15px;
            letter-spacing: 0.25px; color: #979797;">{{inputSubText}}
              <span *ngIf="custom"> {{custom}}</span>
            </div>
          </ng-container>
          <div class="mt-2" *ngIf="!dimension && maxSize"
               style="font-size: 13px; font-style: normal; font-weight: 400; line-height: 15px;
               letter-spacing: 0.25px; color: #979797;">{{maxSize/1000000}}MB max file size.
            <span *ngIf="custom"> {{custom}}</span>
          </div>

        </div>
        <img *ngIf="!isUploading && !!preview" style="height: 64px; object-fit: none; padding-bottom: 10px" [src]="preview" />
        <div class="file-name" *ngIf="!isUploading && file && !(fileURL || fileName) && !preview"
              style="margin-top: 11px; padding-bottom: 10px">{{file.name?.length > 20 ? file.name?.substring(0,20) + '...' : file.name}}</div>
        <div class="file-name" *ngIf="!isUploading && (fileURL || fileName)" style="margin-top: 11px; padding-bottom: 10px">
          <span *ngIf="fileName; else fileURLBlock">{{fileName?.length > 20 ? fileName.substring(0,20) + '...' : fileName}}</span>
          <ng-template #fileURLBlock>
            <span>{{fileURL?.length > 20 ? fileURL.substring(0,20) + '...' : fileURL}}</span>
          </ng-template>
        </div>
        <div *ngIf="isUploading" style="margin-top: 14px; margin-left: 12px; margin-right: 12px; padding-bottom: 10px">
          <beaconstac-progress-bar [current]="currentProgress" [total]="100"></beaconstac-progress-bar>
          <div class="text-center mt-2" style="font-size: 13px; font-style: normal; font-weight: 400; line-height: 15px; letter-spacing: 0.25px;">Uploading...</div>
        </div>
        <span *ngIf="!isUploading && !(!file && !preview && !disabled && !fileURL)">
          <beaconstac-button
            [disabled]="disabled"
            (onClick)="$event.preventDefault(); onFileRemoved()"
            [type]="BUTTON_TYPES.DANGER" [label]="'Remove'" [style]="BUTTON_STYLES.TEXT"></beaconstac-button>
        </span>
      </div>
    </div>
    <input class="drop-zone-input-hidden" type="file" #browse [accept]="acceptTypes.join(',')"
           (change)="$event.target.files && onFileBrowsed($event.target.files[0])" [disabled]="isUploading || disabled">
  </ng-template>
</ngx-file-drop>
<div class="alert alert-danger mt-2"
     [ngStyle]="{'max-width': width}"
     *ngIf="_error">
  {{ _error }} <span *ngIf="hintGoogleDriveUpload">
  <a href="https://docs.beaconstac.com/en/articles/3019106-how-to-convert-a-pdf-to-a-qr-code"
     target="_blank">Learn more</a></span>
</div>